import { ReagentGroupInfo } from "../../../backend/src/types";
import { errorMessage } from "../function/errorMessage";

type Response<T> = {
  data: T;
  error?: any;
};

export const reagentFetcher = async (
  url: string
): Promise<ReagentGroupInfo[]> => {
  try {
    const res = await fetch(url);
    const { data, error }: Response<ReagentGroupInfo[]> = await res.json();

    if (!res.ok || !data) {
      throw new Error(error ?? "Server Error");
    }

    return data;
  } catch (error) {
    errorMessage("試薬リストの取得に失敗しました", error);
    throw [];
  }
};
